<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Chili Template toevoegen
                </template>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Naam">
                      <b-form-input type="text" required v-model="item.name"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" md="6">
                    <b-form-group label="Chili Publish Item ID">
                      <b-form-input type="text" required v-model="item.chili_item_id"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" md="6">
                    <b-form-group label="Chili Workspace ID">
                      <b-form-input type="text" required v-model="item.chili_workspace_id"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Info">
                      <ckeditor v-model="item.description" :editor="editor" :config="editorConfig"></ckeditor>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="3" md="3">
                    <b-form-group label="Categorie">
                      <b-form-select v-model="item.chili_category_id" :options="categoryOptions" required></b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3" md="3">
                    <b-form-group label="Type">
                      <b-form-select v-model="item.type" :options="typeOptions" required></b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-form-group label="Thumbail">
                      <b-form-file v-model="featuredImageFile" placeholder="Selecteer een bestand..."></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
                <template slot="footer">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Toevoegen</b-button>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
import {addData, getData} from '../../api';
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

  export default {
    name: 'chili-template',

    components: {
      ClassicEditor
    },

    data() {
      return {
        saveButtonDisabled: false,
        item: {},
        featuredImageFile: null,

        categoryOptions: [],

        typeOptions: [
          {text: 'Poster', value: 'poster'},
          {text: 'Flyer', value: 'flyer'},
          {text: 'Socials', value: 'socials'},
          {text: 'Website', value: 'website'},
          {text: 'Materiaal', value: 'items'},
          {text: 'Promotie', value: 'promotion'},
          {text: 'Overige', value: 'other'},
        ],

        editor: ClassicEditor,

        editorConfig: {
          toolbar:  ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', '|', 'insertTable'],
          table: {
            contentToolbar: [
              'tableColumn',
              'tableRow',
              'mergeTableCells'
            ]
          },
          heading: {
            options: [
              { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
              { model: 'heading2', view: 'h2', title: 'Heading 2'},
              { model: 'heading3', view: 'h3', title: 'Heading 3'},
              { model: 'heading4', view: 'h4', title: 'Heading 4'},
            ]
          }
        }
      };
    },
    methods: {
      async addItem() {
        this.saveButtonDisabled = true;

        let formData = new FormData();
        Object.keys(this.item).forEach(key => {
          formData.append(key, this.item[key]);
        });

        const request = await addData('chili-templates', formData);

        if (request.status === 201) {
          this.$router.push({ name: 'chili-templates.view', params: { id: request.data.data.id } });
        } else {
          this.saveButtonDisabled = false;
        }
      },
      async getCategoryOptions() {
        this.categoryOptions = await getData('chili-templates/categories').then(
          (response) => response.data
        );
      },
    },
    watch: {
      'featuredImageFile'(newValue) {
        this.item.new_featured_image = newValue;
      }
    },
    beforeMount() {
      this.getCategoryOptions();
    },
  };
</script>

<style>
.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
